// extracted by mini-css-extract-plugin
export default {"trash":"ft06s___ModelList-module__trash","row":"_3sAKR___ModelList-module__row"};